// @ts-nocheck
import '../../sass/pages/_trivia100Years.scss';

import { loadButterflys } from "../utils/helpers";

import Modal from "../components/modal";
import { apiService } from "../services/api";
const api = new apiService();

window.addEventListener('load', () => {
    trivia100Years()
    loadModals()
})

async function loadModals() {
    const userTapit: any = await api.getUSerTapit()
    let shareContents = document.querySelectorAll('#shareModal [data-share]')

    new Modal('#shareModal', {
        activator: '#shareModalButton, #videoShareBtn, #registerShareBtn',
        onOpen: () => {
            let activeSection;
            if (!userTapit.message) activeSection = Array.from(shareContents).find(content => content.getAttribute('data-share') == 'logged')
            else activeSection = Array.from(shareContents).find(content => content.getAttribute('data-share') == 'nologged')
            activeSection.classList.remove('ca-share-modal--hide')
        }
    })
}

export const trivia100Years = async () => {
    loadButterflys("trivia")
}